import { FunctionComponent } from 'react';

import { ClaimFlowType } from 'types';

import StickyButton from 'chime-ui/components/StickyButton';
import { SmallTitle, StandardText, Text } from 'chime-ui/components/Typography';

import useTransactionType from 'hooks/useTransactionType';
import { useUserContext } from 'hooks/useUserContext';

import ErrorGeneric from './Generic';

const ErrorClaimed: FunctionComponent = () => {
  const { claimType } = useTransactionType();
  const isReceiveTransactionType = claimType === ClaimFlowType.receive;

  const [userData] = useUserContext();
  const referralToken = userData?.referralToken;

  if (isReceiveTransactionType) {
    return (
      <ErrorGeneric
        showLogin={false}
        cta={
          <StickyButton
            as="a"
            href={`${process.env.MARKETING_HOST}/r/${referralToken}`}
          >
            Join Chime
          </StickyButton>
        }
      >
        <SmallTitle>
          <Text capitalize>Payment</Text> already made
        </SmallTitle>
        <StandardText>This payment has already been made.</StandardText>
      </ErrorGeneric>
    );
  }

  return (
    <ErrorGeneric>
      <SmallTitle>
        <Text capitalize>Payment</Text> already claimed
      </SmallTitle>
      <StandardText>
        This payment has already been claimed. If this wasn&apos;t you, please
        contact us immediately.
      </StandardText>
    </ErrorGeneric>
  );
};

export default ErrorClaimed;
